import { routes as profileRoutes } from 'modules/Profile/routing'

const routes = {
  root: `${profileRoutes.root}/notifications`,
}

export default routes
